import {
    FETCH_WEBVIEW_ORDERDETAILS,
    SHOW_RETURNS_LOADER,
    WEB_GET_RETURNS_COMPLETE,
    WEB_GET_REPORT_ISSUE_COMPLETE,
    WEB_GET_RETURNS_LINE_ITEMSREQUEST,
    WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS,
    WEB_GET_REPORT_ISSUE_LINE_ITEMS,
    WEB_GET_REPORT_ISSUE_LINE_ITEMSREQUEST,
} from 'yoda-site-components/lib/actionTypes/NativeAppActionTypes';
import { call, takeLatest, put, race, delay, take, all, select } from 'redux-saga/effects';
import { getReturnsLineItems } from 'yoda-site-components/lib/actions/NativeAppAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { postMarketPlaceReturn, postMarketPlaceIncident } from 'yoda-interfaces/lib/Order/OrderApi';
import { get } from 'lodash';
import { formatReturnsLineItem } from '../helpers/Utils';
import {
    SUBMIT_MARKETPLACE_RETURN,
    SUBMIT_MARKETPLACE_RETURN_FAILURE,
    SUBMIT_MARKETPLACE_RETURN_SUCCESS,
    SUBMIT_MARKETPLACE_INCIDENT,
    SUBMIT_MARKETPLACE_INCIDENT_SUCCESS,
    SUBMIT_MARKETPLACE_INCIDENT_FAILURE,
} from '../actionTypes/MarketplaceReturnActionTypes';
import { MKTPLC_CONFIRM_RETURNS_ANALYTICS_ACTION } from '../actionTypes/MyOrdersActionTypes';

function* setWebviewReturnsLineItemsSaga(action) {
    const { payload } = action;
    if (payload?.lineItems) {
        const formattedLineItems = yield call(
            formatReturnsLineItem,
            payload?.lineItems,
            payload?.returns
        );
        yield put({
            type: WEB_GET_RETURNS_LINE_ITEMSREQUEST_SUCCESS,
            payload: { ...payload, lineItems: formattedLineItems },
        });
    }
}

function* getWebviewOrderDetails() {
    yield all([put({ type: SHOW_RETURNS_LOADER, payload: true }), put(getReturnsLineItems())]);
    const { response, timeout } = yield race({
        response: take(WEB_GET_RETURNS_LINE_ITEMSREQUEST),
        timeout: delay(10000),
    });
    yield put({ type: SHOW_RETURNS_LOADER, payload: false });
    if (response) {
        yield call(setWebviewReturnsLineItemsSaga, response);
    } else if (timeout) {
        // log the its been timedout if needed
    }
}

function* getWebviewIncidentDetails() {
    yield put({ type: SHOW_RETURNS_LOADER, payload: true });
    const { response, timeout } = yield race({
        response: take(WEB_GET_REPORT_ISSUE_LINE_ITEMSREQUEST),
        timeout: delay(10000),
    });
    yield put({ type: SHOW_RETURNS_LOADER, payload: false });
    if (response) {
        yield call(setWebviewReturnsLineItemsSaga, response);
    } else if (timeout) {
        // log timeout if needed
    }
}

function* submitMarketPlaceReturns(action) {
    const { payload } = action;
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: true });
    const result = yield call(FactorySaga, postMarketPlaceReturn, { payload });
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: false });
    const isNative = yield select((state) => get(state, 'context.isNative', false));
    if (result?.isSuccess) {
        yield put({
            type: MKTPLC_CONFIRM_RETURNS_ANALYTICS_ACTION,
            payload: { eventName: 'confirmreturn:mp' },
        });
        const payload = {
            isReturnSuccess: true,
            returnSuccess: result?.response.data,
        };
        yield put({ type: SUBMIT_MARKETPLACE_RETURN_SUCCESS, payload });
        if (isNative) {
            yield put({
                type: WEB_GET_RETURNS_COMPLETE,
                payload: {
                    data: {
                        title: 'Return Request Submitted',
                        status: true,
                        didUserTapClosed: false,
                    },
                },
            });
        }
    } else {
        const payload = {
            isReturnError: true,
            returnError: result?.response?.data,
        };
        yield put({ type: SUBMIT_MARKETPLACE_RETURN_FAILURE, payload });
        if (isNative) {
            yield put({
                type: WEB_GET_RETURNS_COMPLETE,
                payload: { data: { title: '', status: false, didUserTapClosed: false } },
            });
        }
    }
}
function* submitMarketPlaceIncidents(action) {
    const { payload } = action;
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: true });
    const result = yield call(FactorySaga, postMarketPlaceIncident, { payload });
    yield put({ type: 'SHOW_RETURNS_LOADER', payload: false });
    const isNative = yield select((state) => get(state, 'context.isNative', false));
    const responseData = result?.response?.data;
    const allSuccess =
        result?.isSuccess && responseData?.incidentResults?.every((r) => r.message === 'Success');
    if (allSuccess) {
        yield put({
            type: SUBMIT_MARKETPLACE_INCIDENT_SUCCESS,
            payload: { isReturnSuccess: true, returnSuccess: responseData },
        });
        if (isNative) {
            yield put({
                type: WEB_GET_REPORT_ISSUE_COMPLETE,
                payload: {
                    data: {
                        title: 'Issue Report Submitted',
                        status: true,
                        didUserTapClosed: false,
                    },
                },
            });
        }
    } else {
        yield put({
            type: SUBMIT_MARKETPLACE_INCIDENT_FAILURE,
            payload: { isReturnError: true, isDuplicateIncident: result?.isSuccess },
        });
        if (isNative) {
            yield put({
                type: WEB_GET_REPORT_ISSUE_COMPLETE,
                payload: {
                    data: { title: 'Report an Issue', status: false, didUserTapClosed: false },
                },
            });
        }
    }
}

function* watchMarketplaceReturnSaga() {
    yield takeLatest(FETCH_WEBVIEW_ORDERDETAILS, getWebviewOrderDetails);
    yield takeLatest(WEB_GET_REPORT_ISSUE_LINE_ITEMS, getWebviewIncidentDetails);
    yield takeLatest(SUBMIT_MARKETPLACE_RETURN, submitMarketPlaceReturns);
    yield takeLatest(SUBMIT_MARKETPLACE_INCIDENT, submitMarketPlaceIncidents);
}

watchMarketplaceReturnSaga.sagaName = 'marketplaceReturnSaga';
export default watchMarketplaceReturnSaga;
